import { useEffect, useState } from "react";
import classNames from "classnames";
import Button from "components/Button";
import { useFormik } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import {
  GetBalance,
  UpdateBalance,
  GetListBalance,
  GetBalanceTransfer,
} from "helpers/api";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import Modal from "components/Modal";
import Table from "components/table/table";

const Balance = () => {
  const [list, setList] = useState(null);
  const [modified, setModified] = useState(null);

  const [data, setData] = useState(null);
  const [solde, setSolde] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const columns = [
    {
      key: "updatedAt",
      label: "Date",
      customRenderers: (item) => (
        <div>{moment(item?.updatedAt).format("DD/MM/YYYY hh:mm")}</div>
      ),
    },

    {
      key: "balanceEuro",
      label: "Swift reçu EUR",
      customRenderers: (item) => <div>{item?.balanceEuro?.toFixed(2)}</div>,
    },
    {
      key: "fxrate",
      label: "Taux",
    },
    {
      key: "balanceTND",
      label: "Swift convertit TND",
      customRenderers: (item) => <div>{item?.balanceTND?.toFixed(2)}</div>,
    },
  ];
  useEffect(() => {
    async function fetchData() {
      await GetBalance()
        .then((response) => {
          setData(response);
        })
        .catch(() => {
          console.log("error");
        });
    }
    async function fetchData2() {
      await GetBalanceTransfer()
        .then((response) => {
          setSolde(response?.resultBalance);
        })
        .catch(() => {
          console.log("error");
        });
    }
    async function fetchData1() {
      await GetListBalance()
        .then((response) => {
          setList(response?.balances);
        })
        .catch(() => {
          console.log("error");
        });
    }
    fetchData();
    fetchData1();
    fetchData2();
  }, [modified]);
  const formik = useFormik({
    initialValues: {
      soldeBalance: 0,
      taux: 0,
    },
    validationSchema: yup.object({
      soldeBalance: yup.string().trim().required("Ce champ est requis"),
      taux: yup.string().trim().required("Ce champ est requis"),
    }),

    onSubmit: (values) => {
      UpdateBalance({
        settingId: data?.settings[0]?._id,
        balance: values.soldeBalance,
        fxrate: values.taux,
      })
        .then((response) => {
          toast("Balance mise à jour  avec succèe", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            type: "success",
          });
          setOpenModal(false);
          formik.resetForm();
          setModified(!modified);
        })
        .catch((err) => {
          toast("Erreur", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            type: "error",
          });
        });
    },
  });
  const handleChange1 = (e) => {
    const inputValue = e.target.value;
    if (/^\d*\.?\d*$/.test(inputValue)) {
      // formik.setValues({
      //   soldeBalance: inputValue,
      //   taux:formik?.values?.taux,
      // });
      formik.setFieldValue("soldeBalance", inputValue);
    }
  };
  const handleChange2 = (e) => {
    const inputValue = e.target.value;
    if (/^\d*\.?\d*$/.test(inputValue)) {
      // formik.setValues({
      //   soldeBalance:formik?.values?.soldeBalance,
      //   taux: inputValue,
      // });
      formik.setFieldValue("taux", inputValue);
    }
  };
  return (
    <div className="flex flex-col mx-[30px] my-[30px] min-h-full w-full justify-center">
      <div className="text-[#5d55e8] text-[18px] h-[27px] mt-[16px] mb-8 font-bold   flex items-center justify-center rounded mx-auto ">
        Balance EASY TRANSFER
      </div>
      <div className="w-full flex flex-col items-center justify-between">
        <div className="flex gap-2  items-center mb-8">
          <span className="font-semibold text-[16px] w-[300px] text-left">
            Date de derniere alimentation :
          </span>
          <span className="text-[16px] w-[250px] text-left">
            {moment(data?.settings[0]?.updatedAt).format("DD/MM/YYYY hh:mm")}
          </span>
        </div>

        <div className="flex  gap-2 items-center">
          <span className="font-semibold text-[16px] w-[300px] text-left">
            Solde balance :
          </span>
          <span className="text-[16px] w-[250px] text-left">{solde} TND</span>
        </div>

        <div className="  flex flex-col gap-4 mt-[50px]  ">
          <Button variant="primary" onClick={() => setOpenModal(true)}>
            <div className="flex items-center justify-center gap-10  w-full  ">
              <div className="text-sm font-bold text-white text-[18px]">
                Alimentez la balance
              </div>
            </div>
          </Button>
        </div>
      </div>
      <div className=" w-full flex justify-center mt-[100px]">
        <Table
          data={list}
          columns={columns}
          withColumn={"w-[200px]"}
          withContainer={"w-[1600px] lg:w-[1000px]"}
        />
      </div>

      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          formik.resetForm();
        }}
        className=" h-[400px] w-[550px] "
      >
        <form
          onSubmit={formik.handleSubmit}
          className="w-full flex flex-col items-center justify-between px-12"
        >
          <span className=" text-[24px] font-bold text-[#5d55e8] my-10 ">
            Alimentation de la balance
          </span>

          <div className="flex justify-center items-center">
            <span className="font-semibold text-[20px] w-[250px] text-left">
              Montant du swift EUR :
            </span>

            <input
              placeholder="Solde"
              autoComplete="off"
              onChange={(e) => handleChange1(e)}
              onBlur={formik.handleBlur}
              id="soldeBalance"
              name="solde Balance"
              value={formik.values.soldeBalance}
              className={classNames(
                " text-left mt-[8px] border-[1px] border-[#292524] resize-none px-4  py-4   w-[200px] h-[50px] rounded  bg-white text-sm text-[#1E2E58] placeholder-[#8E96AB] border-lena2021-gray-light"
              )}
            />
          </div>
          {formik.touched.soldeBalance && (
            <span className="2xl:text-xs mt-1.5 text-sm h-5 relative left-1 sm:text-10 text-[#DC143C] ">
              {formik.errors.soldeBalance}
            </span>
          )}
          <div className="flex justify-center items-center">
            <span className="font-semibold text-[20px] w-[250px] text-left">
              Taux de change :
            </span>
            <input
              placeholder="Taux"
              autoComplete="off"
              onChange={(e) => handleChange2(e)}
              onBlur={formik.handleBlur}
              id="taux"
              name="taux"
              value={formik.values.taux}
              className={classNames(
                " text-left mt-[8px] border-[1px] border-[#292524] resize-none px-4  py-4   w-[200px] h-[50px] rounded  bg-white text-sm text-[#1E2E58] placeholder-[#8E96AB] border-lena2021-gray-light"
              )}
            />
          </div>
          {formik.touched.taux && (
            <span className="2xl:text-xs mt-1.5 text-sm h-5 relative left-1 sm:text-10 text-[#DC143C] ">
              {formik.errors.taux}
            </span>
          )}
          <div className="  flex flex-col gap-4 mt-[50px]  ">
            <Button
              type="submit"
              variant={
                formik?.values?.soldeBalance <= 0 && formik?.values?.taux <= 0
                  ? "grey"
                  : "primary"
              }
              disabled={
                formik?.values?.soldeBalance <= 0 && formik?.values?.taux <= 0
              }
            >
              Confirmez
            </Button>
          </div>
        </form>
      </Modal>
      <ToastContainer />
    </div>
  );
};

export default Balance;
